import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { BackgroundColorOptions, StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';


let BASE_URL = 'https://avlerinfo.dk/sortsinfo/?alttemplate=ASB_sortsbeskrivelser' ;


@Component({
  selector: 'app-sortsinfo',
  templateUrl: 'sortsinfo.page.html',
  styleUrls: ['sortsinfo.page.scss']
})
export class SortsinfoPage {

  safeUrl: any ;
  constructor(private domSanit: DomSanitizer) {
    this.safeUrl = this.getSafeUrl();
  }

  ionViewDidEnter() {
    if (Capacitor.isPluginAvailable('StatusBar')) {
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.setBackgroundColor({color:'#00A25E'});
    }
  }

  getSafeUrl() {
    // Get auth token from localStorage
    const token = localStorage.getItem('access_token');
    
    // Append token as query parameter to URL
    const urlWithToken = token ? `${BASE_URL}&access_token=${token}` : BASE_URL;
    
    // Log for debugging (remove in production)
    console.log('Loading URL with token:', urlWithToken);
    
    return this.domSanit.bypassSecurityTrustResourceUrl(urlWithToken);
  }

  ionViewWillEnter(): void {
      this.safeUrl = this.getSafeUrl() ;
  }

}


